import React, { useEffect, useRef, useState } from 'react';
import { Typography } from 'antd';
import { useTranslation } from '../i18n';
import CaptchaLa from './CaptchaLa';

/**
 * 表单内人机验证（2026-10-20）：业主要求验证码不要单独弹窗。
 *
 * 放在表单提交按钮上方：<InlineCaptcha />。请求被 RateLimitMiddleware 拦下（430，captcha.la）时，
 * CaptchaModal 先问 inlineCaptchaHost()，有承载位就把事件交给它——验证栏直接出现在表单里，
 * 通过后自动重试原请求（与原弹窗同一条 apiClient 队列）。页面没有承载位时 CaptchaModal 才兜底弹窗。
 */
const hosts = [];

/** 当前页面最上层的表单承载位（没有则返回 null） */
export function inlineCaptchaHost() {
    return hosts.length ? hosts[hosts.length - 1] : null;
}

const InlineCaptcha = ({ action = 'login', style }) => {
    const { t } = useTranslation();
    const [detail, setDetail] = useState(null);
    const pending = useRef(null);

    useEffect(() => {
        const host = { show: (d) => { pending.current = d; setDetail(d); } };
        hosts.push(host);
        return () => {
            const i = hosts.indexOf(host);
            if (i >= 0) hosts.splice(i, 1);
            // leaving the page with a challenge open: release the queued request
            if (pending.current?.onCancel) pending.current.onCancel();
            pending.current = null;
        };
    }, []);

    if (!detail) return null;

    const onVerify = (token) => {
        const d = pending.current;
        pending.current = null;
        setDetail(null);
        if (d?.onSuccess) d.onSuccess(token, '', 'captchala');
    };

    return (
        <div style={{ marginBottom: 16, ...style }}>
            <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 8, fontSize: 13 }}>
                {t('Please complete the human check to continue')}
            </Typography.Text>
            <CaptchaLa product="float" action={action} onVerify={onVerify} />
        </div>
    );
};

export default InlineCaptcha;
